module.exports = __webpack_public_path__ + "assets/8bfdd9c31b5c61562b71b4e1c4b970ea-DSC_0811.jpg";